import React, { useState } from 'react';
import './OrientationSession.css';

const SOURCE_OPTIONS = [
  'Friend / Family Referral',
  'School / College Recommendation',
  'Google Search',
  'Social Media (Instagram / Facebook)',
  'YouTube',
  'LinkedIn',
  'WhatsApp',
  'Newspaper / Magazine',
  'Event / Hackathon',
  'ibots Website',
  'Other',
];

const errStyle = { color: '#e8394d', fontSize: '11px', marginTop: '4px' };

function OrientationSession({ onClose }) {
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    institution: '', contactPerson: '', phone: '',
    email: '', city: '', eventDate: '',
    participants: '', audience: '', domain: '',
    customDomain: '', venue: '', avEquipment: '', requirements: '',
    source: '', customSource: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.institution) newErrors.institution = 'Institution name is required';
    if (!formData.contactPerson) newErrors.contactPerson = 'Contact person name is required';
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.city) newErrors.city = 'City is required';
    if (!formData.eventDate) newErrors.eventDate = 'Preferred event date is required';
    if (!formData.participants) newErrors.participants = 'Number of participants is required';
    if (!formData.domain) newErrors.domain = 'Please select a domain';
    if (!formData.source) newErrors.source = 'Please tell us how you heard about ibots';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      await fetch('http://localhost:5000/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formType:      'orientation-session',
          institution:   formData.institution,
          contactPerson: formData.contactPerson,
          phone:         formData.phone,
          email:         formData.email,
          city:          formData.city,
          eventDate:     formData.eventDate,
          participants:  formData.participants,
          audience:      formData.audience,
          domain:        formData.domain,
          customDomain:  formData.customDomain,
          venue:         formData.venue,
          avEquipment:   formData.avEquipment,
          requirements:  formData.requirements,
          source:        formData.source === 'Other' ? formData.customSource : formData.source,
        }),
      });
    } catch (err) {
      console.log('Your backend error:', err);
    }

    try {
      await fetch('http://localhost:5000/api/campus', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
  name:          formData.contactPerson,
  type:          'College',
  phone:         formData.phone,
  email:         formData.email,
  institution:   formData.institution,
  city:          formData.city || '',
  eventDate:     formData.eventDate || '',
  participants:  formData.participants || '',
  audience: ({
  'ug1': 'UG 1st Year', 'ug2': 'UG 2nd Year', 'ug3': 'UG 3rd Year', 'ug4': 'UG 4th Year',
  'pg1': 'PG 1st Year', 'pg2': 'PG 2nd Year',
  'school': 'School Students', 'mixed': 'Mixed Audience',
}[formData.audience] || formData.audience || ''),
  domain:        formData.domain === 'other' ? formData.customDomain : formData.domain || '',
  venue: ({
  'classroom':  'Classroom',
  'seminar':    'Seminar Hall',
  'auditorium': 'Auditorium',
  'lab':        'Computer Lab',
  'outdoor':    'Outdoor / Open Area',
}[formData.venue] || formData.venue || ''),
  avEquipment:   ({
  'projector': 'Projector & Screen',
  'tv':        'TV / LED Screen',
  'both':      'Both (TV & Projector)',
  'none':      'None / Not Available',
}[formData.avEquipment] || formData.avEquipment || ''),
  requirements:  formData.requirements || '',
  mode:          'Offline',
  formType:      'Orientation Session',
  source:        formData.source === 'Other' ? formData.customSource : formData.source,
}),
      });
    } catch (err) {
      console.log('Training dashboard error:', err);
    }

    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="os__overlay" onClick={onClose}>
        <div className="os__box" onClick={(e) => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center', gap: '16px' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#dcfce7', color: '#16a34a', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900 }}>✓</div>
          <h2 style={{ color: '#0d2e6e', fontWeight: 900, margin: 0 }}>Thank You for Reaching Out to ibots!</h2>
          <p style={{ color: '#64748b', margin: 0, maxWidth: '300px', lineHeight: '1.6' }}>We have received your Orientation Session booking request. Our team will get in touch with you within <strong>24 hours</strong> to confirm the session details.</p>
          <button className="os__submit" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="os__overlay" onClick={onClose}>
      <div className="os__box" onClick={(e) => e.stopPropagation()}>

        <button className="os__close" onClick={onClose}>✕ Close</button>
        <h2 className="os__title">Orientation Session — Details & Booking</h2>
        <p className="os__subtitle">A structured full-day technology awareness program conducted at your campus by certified iBots trainers, designed to build foundational understanding of emerging technologies.</p>

        <div className="os__stats">
          <div className="os__stat"><p className="os__stat-value">₹15,000</p><p className="os__stat-label">Session Fee / Day</p></div>
          <div className="os__stat"><p className="os__stat-value">6 Hours</p><p className="os__stat-label">Session Duration</p></div>
          <div className="os__stat"><p className="os__stat-value">Any Size</p><p className="os__stat-label">Batch Capacity</p></div>
          <div className="os__stat"><p className="os__stat-value">Your Campus</p><p className="os__stat-label">Place</p></div>
        </div>

        <div className="os__two-cols">
          <div className="os__col-card">
            <p className="os__col-title">Session Covers</p>
            <ul className="os__col-list">
              {['Overview of Electronics & Embedded Systems','Internet of Things (IoT) & Smart Devices','Robotics & Automation Fundamentals','AI & Emerging Technology Trends','Live demonstrations with real hardware','Hands-on sessions with guided practice using kits and components','Interactive Q&A and engagement activities'].map((item, i) => (
                <li key={i}><span className="os__check">✓</span> {item}</li>
              ))}
            </ul>
          </div>
          <div className="os__col-card">
            <p className="os__col-title">Ideal For</p>
            <ul className="os__col-list">
              {['Freshers orientation / induction programs','Department-level technical awareness days','Annual technical festivals & symposiums','STEM awareness and skill exposure drives','Industry–academia engagement events'].map((item, i) => (
                <li key={i}><span className="os__arrow">→</span> {item}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="os__logistics">
          <span className="os__logistics-icon">✈️</span>
          <div>
            <p className="os__logistics-title">Logistics Policy — Travel & Accommodation</p>
            <p className="os__logistics-desc">Travel arrangements and accommodation (where applicable) for the ibots trainer / speaker are the responsibility of the organising institution and are to be arranged and borne entirely by them. These costs are independent of the session fee quoted. Please factor these into your event budget accordingly.</p>
          </div>
        </div>

        <h3 className="os__form-title">Book This Session — Requirement Form</h3>

        <div className="os__form">
          <div className="os__row">
            <div className="os__group">
              <label className="os__label">Institution Name *</label>
              <input type="text" name="institution" value={formData.institution}
                onChange={handleChange} placeholder="Enter your institution name" className="os__input" />
              {errors.institution && <p style={errStyle} className="error-field">{errors.institution}</p>}
            </div>
            <div className="os__group">
              <label className="os__label">Contact Person Name *</label>
              <input type="text" name="contactPerson" value={formData.contactPerson}
                onChange={handleChange} placeholder="Name of coordinator / HOD" className="os__input" />
              {errors.contactPerson && <p style={errStyle} className="error-field">{errors.contactPerson}</p>}
            </div>
          </div>

          <div className="os__row">
            <div className="os__group">
              <label className="os__label">Phone Number *</label>
              <input type="text" name="phone" value={formData.phone}
                onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="os__input" />
              {errors.phone && <p style={errStyle} className="error-field">{errors.phone}</p>}
            </div>
            <div className="os__group">
              <label className="os__label">Email Address *</label>
              <input type="email" name="email" value={formData.email}
                onChange={handleChange} placeholder="official@institution.edu" className="os__input" />
              {errors.email && <p style={errStyle} className="error-field">{errors.email}</p>}
            </div>
          </div>

          <div className="os__row">
            <div className="os__group">
              <label className="os__label">Institution City / Location *</label>
              <input type="text" name="city" value={formData.city}
                onChange={handleChange} placeholder="City, Tamil Nadu" className="os__input" />
              {errors.city && <p style={errStyle} className="error-field">{errors.city}</p>}
            </div>
            <div className="os__group">
              <label className="os__label">Preferred Event Date *</label>
              <input type="text" name="eventDate" value={formData.eventDate}
                onChange={handleChange} placeholder="e.g. 15 June 2025 or June 2025" className="os__input" />
              {errors.eventDate && <p style={errStyle} className="error-field">{errors.eventDate}</p>}
            </div>
          </div>

          <div className="os__row">
            <div className="os__group">
              <label className="os__label">Expected Number of Participants *</label>
              <input type="text" name="participants" value={formData.participants}
                onChange={handleChange} placeholder="e.g. 120 students" className="os__input" />
              {errors.participants && <p style={errStyle} className="error-field">{errors.participants}</p>}
            </div>
            <div className="os__group">
              <label className="os__label">Target Audience</label>
              <select name="audience" value={formData.audience}
                onChange={handleChange} className="os__input os__select">
                <option value="">Select audience...</option>
                <option value="ug1">UG 1st Year</option>
                <option value="ug2">UG 2nd Year</option>
                <option value="ug3">UG 3rd Year</option>
                <option value="ug4">UG 4th Year</option>
                <option value="pg">PG Students</option>
                <option value="faculty">Faculty</option>
                <option value="mixed">Mixed (Students + Faculty)</option>
              </select>
            </div>
          </div>

          <div className="os__row">
            <div className="os__group">
              <label className="os__label">Preferred Domain / Topic *</label>
              <select name="domain" value={formData.domain}
                onChange={handleChange} className="os__input os__select os__select--focus">
                <option value="">Select preferred domain...</option>
                <option value="electronics">Electronics & Embedded Systems</option>
                <option value="iot">Internet of Things (IoT)</option>
                <option value="robotics">Robotics & Automation</option>
                <option value="ai">Artificial Intelligence & Machine Learning</option>
                <option value="drone">Drone Technology</option>
                <option value="mechatronics">Mechatronics</option>
                <option value="general">General Technology Awareness (All Domains)</option>
                <option value="other">Other (specify below)</option>
              </select>
              {errors.domain && <p style={errStyle}>{errors.domain}</p>}
              {formData.domain === 'other' && (
                <input type="text" name="customDomain" value={formData.customDomain}
                  onChange={handleChange} placeholder="Specify your domain or topic..."
                  className="os__input os__input--mt" />
              )}
            </div>
            <div className="os__group">
              <label className="os__label">Venue Available</label>
              <select name="venue" value={formData.venue}
                onChange={handleChange} className="os__input os__select">
                <option value="">Select venue type...</option>
                <option value="auditorium">Auditorium</option>
                <option value="seminar">Seminar Hall</option>
                <option value="classroom">Classroom</option>
                <option value="lab">Lab</option>
                <option value="outdoor">Open Area / Outdoor</option>
                <option value="none">No venue — ibots to arrange</option>
              </select>
            </div>
          </div>

          <div className="os__group os__group--half">
            <label className="os__label">AV Equipment Available</label>
            <select name="avEquipment" value={formData.avEquipment}
              onChange={handleChange} className="os__input os__select">
              <option value="">Select...</option>
              <option value="projector">Projector & Screen</option>
              <option value="tv">LED TV / Display</option>
              <option value="both">Both Projector & TV</option>
              <option value="none">None — ibots to arrange</option>
            </select>
          </div>

          <div className="os__group os__group--full">
            <label className="os__label">Additional Requirements or Context</label>
            <textarea name="requirements" value={formData.requirements} onChange={handleChange}
              placeholder="Purpose of the event, any specific topic requests, special requirements, or other relevant information..."
              className="os__input os__textarea" />
          </div>

          <div className="os__group os__group--full">
            <label className="os__label">How did you hear about ibots? *</label>
            <select name="source" value={formData.source}
              onChange={handleChange} className="os__input os__select">
              <option value="">Select...</option>
              {SOURCE_OPTIONS.map((s) => (<option key={s} value={s}>{s}</option>))}
            </select>
            {errors.source && <p style={errStyle}>{errors.source}</p>}
            {formData.source === 'Other' && (
              <input type="text" name="customSource" value={formData.customSource}
                onChange={handleChange} placeholder="Please tell us how you found us..."
                className="os__input" style={{ marginTop: '8px' }} />
            )}
          </div>

          <button className="os__submit" onClick={handleSubmit}>
            Submit Booking Request →
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrientationSession;